import api from './api';

const HR_BASE = process.env.REACT_APP_API_HR || '/api/hr';

export const employeeService = {
  getAll: (params) => api.get(`${HR_BASE}/employees/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/employees/${id}/`),
  create: (data) => api.post(`${HR_BASE}/employees/`, data),
  update: (id, data) => api.put(`${HR_BASE}/employees/${id}/`, data),
  patch: (id, data) => api.patch(`${HR_BASE}/employees/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/employees/${id}/`),
  getPayslips: (id) => api.get(`${HR_BASE}/employees/${id}/payslips/`),
};

export const departmentService = {
  getAll: (params) => api.get(`${HR_BASE}/departments/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/departments/${id}/`),
  create: (data) => api.post(`${HR_BASE}/departments/`, data),
  update: (id, data) => api.put(`${HR_BASE}/departments/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/departments/${id}/`),
};

export const positionService = {
  getAll: (params) => api.get(`${HR_BASE}/positions/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/positions/${id}/`),
  create: (data) => api.post(`${HR_BASE}/positions/`, data),
  update: (id, data) => api.put(`${HR_BASE}/positions/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/positions/${id}/`),
};

export const attendanceService = {
  getAll: (params) => api.get(`${HR_BASE}/attendance/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/attendance/${id}/`),
  create: (data) => api.post(`${HR_BASE}/attendance/`, data),
  bulkCreate: (data) => api.post(`${HR_BASE}/attendance/bulk_create/`, data),
  update: (id, data) => api.put(`${HR_BASE}/attendance/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/attendance/${id}/`),
  importCrosschex: (formData) => api.post(`${HR_BASE}/attendance/import_crosschex/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  syncCrosschex: (data) => api.post(`${HR_BASE}/attendance/sync_crosschex/`, data),
  testCrosschex: (data) => api.post(`${HR_BASE}/attendance/test_crosschex/`, data),
};

export const leaveService = {
  getTypes: (params) => api.get(`${HR_BASE}/leave-types/`, { params }),
  getRequests: (params) => api.get(`${HR_BASE}/leave-requests/`, { params }),
  getRequest: (id) => api.get(`${HR_BASE}/leave-requests/${id}/`),
  submitRequest: (data) => api.post(`${HR_BASE}/leave-requests/`, data),
  updateRequest: (id, data) => api.put(`${HR_BASE}/leave-requests/${id}/`, data),
  approveRequest: (id, data) => api.post(`${HR_BASE}/leave-requests/${id}/approve/`, data),
  rejectRequest: (id, data) => api.post(`${HR_BASE}/leave-requests/${id}/reject/`, data),
  deleteRequest: (id) => api.delete(`${HR_BASE}/leave-requests/${id}/`),
};

export const payrollService = {
  getPeriods: (params) => api.get(`${HR_BASE}/payroll-periods/`, { params }),
  getPeriod: (id) => api.get(`${HR_BASE}/payroll-periods/${id}/`),
  createPeriod: (data) => api.post(`${HR_BASE}/payroll-periods/`, data),
  updatePeriod: (id, data) => api.put(`${HR_BASE}/payroll-periods/${id}/`, data),
  processPeriod: (id) => api.post(`${HR_BASE}/payroll-periods/${id}/process/`),
  revertPeriod: (id) => api.post(`${HR_BASE}/payroll-periods/${id}/revert/`),
  payPeriod: (id) => api.post(`${HR_BASE}/payroll-periods/${id}/pay/`),

  getPayrolls: (params) => api.get(`${HR_BASE}/payrolls/`, { params }),
  getPayroll: (id) => api.get(`${HR_BASE}/payrolls/${id}/`),
  createPayroll: (data) => api.post(`${HR_BASE}/payrolls/`, data),
  updatePayroll: (id, data) => api.put(`${HR_BASE}/payrolls/${id}/`, data),
  getSummary: (params) => api.get(`${HR_BASE}/payrolls/summary/`, { params }),
};

// ============ Loan Services ============
export const loanService = {
  getAll: (params) => api.get(`${HR_BASE}/loans/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/loans/${id}/`),
  create: (data) => api.post(`${HR_BASE}/loans/`, data),
  update: (id, data) => api.put(`${HR_BASE}/loans/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/loans/${id}/`),
  approve: (id) => api.post(`${HR_BASE}/loans/${id}/approve/`),
  cancel: (id) => api.post(`${HR_BASE}/loans/${id}/cancel/`),
  recordPayment: (id, data) => api.post(`${HR_BASE}/loans/${id}/record_payment/`, data),

  // Loan payments
  getPayments: (params) => api.get(`${HR_BASE}/loan-payments/`, { params }),
};

// ============ Cash Advance Services ============
export const cashAdvanceService = {
  getAll: (params) => api.get(`${HR_BASE}/cash-advances/`, { params }),
  getById: (id) => api.get(`${HR_BASE}/cash-advances/${id}/`),
  create: (data) => api.post(`${HR_BASE}/cash-advances/`, data),
  update: (id, data) => api.put(`${HR_BASE}/cash-advances/${id}/`, data),
  delete: (id) => api.delete(`${HR_BASE}/cash-advances/${id}/`),
  approve: (id) => api.post(`${HR_BASE}/cash-advances/${id}/approve/`),
  disburse: (id) => api.post(`${HR_BASE}/cash-advances/${id}/disburse/`),
  cancel: (id) => api.post(`${HR_BASE}/cash-advances/${id}/cancel/`),

  // Cash advance deductions
  getDeductions: (params) => api.get(`${HR_BASE}/cash-advance-deductions/`, { params }),
};

export const authService = {
  login: (username, password) =>
    api.post('/api/auth/login/', { username, password }),
  verify2FA: (userId, code, tempToken) =>
    api.post('/api/auth/verify-2fa/', { user_id: userId, code, temp_token: tempToken }),
  refresh: (refresh) =>
    api.post('/api/token/refresh/', { refresh }),
  getCurrentUser: () =>
    api.get('/api/users/me/'),
};

export const twoFactorService = {
  getStatus: () => api.get(`${HR_BASE}/2fa/status/`),
  setup: () => api.get(`${HR_BASE}/2fa/setup/`),
  verifySetup: (code) => api.post(`${HR_BASE}/2fa/verify-setup/`, { code }),
  disable: (code, password) => api.post(`${HR_BASE}/2fa/disable/`, { code, password }),
  regenerateCodes: (code) => api.post(`${HR_BASE}/2fa/regenerate-codes/`, { code }),
};
